import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import './ListingTranslateContent.scss';

const GOOGLE_LOGO_PATH = '/images/show-rentable-unit/google-logo.png';
const POWERED_BY_LOGO = '/images/show-rentable-unit/powered-by-google.png';

const GoogleLogo = () => (
  <img
    key="translation-logo"
    src={getResourcePath(GOOGLE_LOGO_PATH)}
    alt="Google Translate"
  />
);

const PoweredByGoogle = () => (
  <img
    className="listing-translate__powered"
    key="powered-logo"
    src={getResourcePath(POWERED_BY_LOGO)}
    alt="Powered by Google"
  />
);

const AutomaticTranslatedContent = () => (
  <Fragment>
    <div className="listing-translate__message">
      {trans('property_show.original_content_toggle.descriptionALT')}
    </div>
    <PoweredByGoogle />
  </Fragment>
);

const OutOfDateTranslation = () =>
  trans('property_show.original_content_toggle.out_of_sync');

// If not automatic, then isOldTranslation. The third case(none of them), is covered at the beginning of the render
const TranslatedContent = ({ isAutomatic }) => {
  if (isAutomatic) {
    return <AutomaticTranslatedContent />;
  }

  return <OutOfDateTranslation />;
};

TranslatedContent.propTypes = {
  isAutomatic: PropTypes.bool.isRequired
};

const OriginalContent = () => (
  <div className="listing-translate__message">
    {trans('property_show.original_content_toggle.description')}
  </div>
);

const TranslateButton = ({
  onChangeLanguage,
  showTranslatedContent,
  isAutomatic
}) => {
  const mustShowLogo = showTranslatedContent && isAutomatic;

  return (
    <Button onClick={onChangeLanguage} color="tertiary" size="small">
      <>
        {mustShowLogo && <GoogleLogo />}
        {showTranslatedContent
          ? trans('property_show.original_content_toggle.buttonALT')
          : trans('property_show.original_content_toggle.button')}
      </>
    </Button>
  );
};

TranslateButton.propTypes = {
  onChangeLanguage: PropTypes.func.isRequired,
  showTranslatedContent: PropTypes.bool.isRequired,
  isAutomatic: PropTypes.bool.isRequired
};

const ListingTranslateContent = props => {
  const isAutomaticTranslation = !props.isManualTranslated;
  const mustShowWarning =
    props.showTranslatedContent && props.isTranslationNeeded;

  const wrapperClassNames = classNames('listing-translate', {
    'listing-translate--warning': mustShowWarning
  });

  return (
    <div className={wrapperClassNames}>
      <TranslateButton
        onChangeLanguage={props.onChangeLanguage}
        showTranslatedContent={props.showTranslatedContent}
        isAutomatic={isAutomaticTranslation}
        mustShowWarning={mustShowWarning}
      />
      {props.showTranslatedContent ? (
        <TranslatedContent
          isAutomatic={isAutomaticTranslation}
          isOldTranslation={props.isTranslationNeeded}
        />
      ) : (
        <OriginalContent />
      )}
    </div>
  );
};

ListingTranslateContent.propTypes = {
  onChangeLanguage: PropTypes.func.isRequired,
  isManualTranslated: PropTypes.bool.isRequired,
  isTranslationNeeded: PropTypes.bool.isRequired,
  showTranslatedContent: PropTypes.bool.isRequired
};

export default ListingTranslateContent;
